import {
  ChangeHandler,
  RegisterOptions,
  UseFormClearErrors,
  UseFormRegister,
  UseFormRegisterReturn,
} from 'react-hook-form';
import { FieldNameOptions, FormData } from './types';
import Lang from '@lang/en';
import { dayjs } from '../../utils';
import isEmail from 'validator/lib/isEmail';

// eslint-disable-next-line no-control-regex
const nameRegex = /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u;

const getRegisteredFieldsForEditPersonal = (
  register: UseFormRegister<FormData>,
  clearErrors: UseFormClearErrors<FormData>,
  isOrderStatusDone?: boolean
): Record<string, UseFormRegisterReturn> => {
  const getDateFieldWithCustomOnChange = (
    fieldName: FieldNameOptions,
    validationRules: RegisterOptions
  ) => {
    const field = register(fieldName as FieldNameOptions, validationRules);
    const customOnChange: ChangeHandler = (event) => {
      clearErrors('birthdateDay');
      return field.onChange(event);
    };
    return {
      ...field,
      onChange: customOnChange,
    };
  };

  const validationEditPersonalModal = {
    nameFirstField: register('firstName', {
      required: Lang.requiredText,
      pattern: {
        value: nameRegex,
        message: Lang.healthCheckEditOrderIncorrectInputValueText,
      },
    }),
    nameLastField: register('lastName', {
      required: Lang.requiredText,
      pattern: {
        value: nameRegex,
        message: Lang.healthCheckEditOrderIncorrectInputValueText,
      },
    }),
    birthdateDayField: getDateFieldWithCustomOnChange('birthdateDay', {
      required: Lang.requiredText,
      pattern: {
        value: /([1-9]|[12]\d|3[01])/,
        message: Lang.healthCheckEditOrderIncorrectInputValueText,
      },
    }),
    birthdateMonthField: getDateFieldWithCustomOnChange('birthdateMonth', {
      required: Lang.requiredText,
      validate: (value) => {
        const month = dayjs(value, 'MMMM');
        return month.isValid()
          ? true
          : Lang.healthCheckEditOrderIncorrectInputValueText;
      },
    }),
    birthdateYearField: getDateFieldWithCustomOnChange('birthdateYear', {
      required: Lang.requiredText,
      pattern: {
        value: /^(19|20)\d{2}$/,
        message: Lang.healthCheckEditOrderIncorrectInputValueText,
      },
    }),
    documentTypeField: register('documentType', {
      required: Lang.requiredText,
    }),
    documentNumberField: register('documentNumber', {
      required: Lang.requiredText,
      maxLength: {
        value: 15,
        message: Lang.healthCheckEditOrderIncorrectDocumentNumberText,
      },
      pattern: {
        value: /^[a-zA-Z0-9]*$/,
        message: Lang.healthCheckEditOrderIncorrectDocumentNumberText,
      },
    }),
    contactEmailField: register('contactEmail', {
      required: Lang.requiredText,
      validate: (email) =>
        isEmail(email)
          ? true
          : Lang.healthCheckEditOrderIncorrectInputValueText,
    }),
  };

  if (isOrderStatusDone)
    return {
      nameFirstField: register('firstName'),
      nameLastField: register('lastName'),
      birthdateDayField: register('birthdateDay'),
      birthdateMonthField: register('birthdateMonth'),
      birthdateYearField: register('birthdateYear'),
      documentTypeField: register('documentType'),
      documentNumberField: register('documentNumber'),
      contactEmailField: register('contactEmail', {
        required: Lang.requiredText,
        validate: (email) =>
          isEmail(email)
            ? true
            : Lang.healthCheckEditOrderIncorrectInputValueText,
      }),
    };

  return validationEditPersonalModal;
};

export default getRegisteredFieldsForEditPersonal;
